var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoppinsV19Latin600(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Poppins",
    horizAdvX: 866
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Poppins SemiBold",
    unitsPerEm: 1000,
    panose1: "0 0 7 0 0 0 0 0 0 0",
    ascent: 1050,
    descent: -350,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    glyphName: "space",
    horizAdvX: 238
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    glyphName: "exclam",
    horizAdvX: 354,
    d: "M250 710L234 227H116L99 710H250ZM140 -7T116 16T91 75Q91 110 115 133T178 157Q215 157 239 134T263 75Q263 40 239 17T178 -7Q140 -7 116 16Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    glyphName: "quotedbl",
    horizAdvX: 364,
    d: "M157 798L145 586H50L37 798H157ZM327 798L314 586H219L206 798H327Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    glyphName: "numbersign",
    horizAdvX: 887,
    d: "M684 449L651 295H778V170H624L588 0H455L491 170H309L273 0H141L177 170H26V295H204L237 449H87V574H264L299 740H431L396 574H578L613 740H746L711 574H839V449H684ZM551 449H369L336 295H518L551 449Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    glyphName: "dollar",
    horizAdvX: 654,
    d: "M567 149T541 104T463 29T341 -6V-87H277V-5Q177 4 116 55T53 195H203Q209 123 277 108V299Q205 317 161 335T85 393T53 502Q53 589 115 644T277 707V788H341V707Q437 699 494 649T559 511H408Q405 540 388 561T341 592V403Q416 384 459 367T535 310T567 201Q567 149 541 104ZM199 476T219 456T277 422V595Q241 590 220 568T199 509Q199 476 219 456ZM379 113T400 137T422 195Q422 228 401 248T341 281V106Q379 113 400 137Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    glyphName: "percent",
    horizAdvX: 829,
    d: "M37 626T81 669T196 712Q266 712 310 669T355 550Q355 473 311 430T196 387Q126 387 82 430T37 550Q37 626 81 669ZM679 700L286 0H150L542 700H679ZM140 628T140 550Q140 471 195 471Q222 471 237 490T252 550Q252 628 195 628Q140 628 140 550ZM476 228T520 270T635 313Q705 313 748 271T792 151Q792 74 749 31T635 -12Q564 -12 520 31T476 151Q476 228 520 270ZM577 229T577 151Q577 72 634 72Q690 72 690 151Q690 229 634 229Q577 229 577 151Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    glyphName: "ampersand",
    horizAdvX: 778,
    d: "M606 0L530 75Q433 -12 293 -12Q216 -12 158 14T67 89T35 202Q35 271 74 326T189 415Q162 448 150 478T138 544Q138 592 163 630T234 691T343 713Q406 713 451 689T518 625T537 536H401Q402 569 385 586T339 604Q311 604 293 588T274 545Q274 520 289 496T338 435L514 261Q516 263 517 265T519 269L576 364H722L652 241Q632 202 609 167L778 0H606ZM379 104T442 162L270 332Q173 289 173 210Q173 165 207 135T297 104Q379 104 442 162Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    glyphName: "quotesingle",
    horizAdvX: 195,
    d: "M157 798L145 586H50L37 798H157Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    glyphName: "parenleft",
    horizAdvX: 485,
    d: "M214 -103T161 43T107 356Q107 527 163 677T326 924H467V911Q357 806 300 659T242 356Q242 204 296 63T452 -183V-197H311Q214 -103 161 43Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    glyphName: "parenright",
    horizAdvX: 485,
    d: "M33 -197V-183Q134 -79 188 62T243 356Q243 512 186 659T18 911V924H159Q266 828 322 678T378 356Q378 189 325 43T174 -197H33Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    glyphName: "asterisk",
    horizAdvX: 518,
    d: "M399 686L449 596L319 549L449 502L397 409L289 498L312 360H208L230 498L123 407L68 503L198 550L69 595L120 687L231 599L208 738H313L289 599L399 686Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    glyphName: "plus",
    horizAdvX: 674,
    d: "M592 295H403V101H271V295H82V417H271V611H403V417H592V295Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    glyphName: "comma",
    horizAdvX: 254,
    d: "M222 147L105 -134H15L80 147H222Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    glyphName: "hyphen",
    horizAdvX: 583,
    d: "M495 416V298H71V416H495Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    glyphName: "period",
    horizAdvX: 260,
    d: "M93 -7T69 16T44 75Q44 110 68 133T131 157Q168 157 192 134T216 75Q216 40 192 17T131 -7Q93 -7 69 16Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    glyphName: "slash",
    horizAdvX: 486,
    d: "M444 947L174 -181H37L307 947H444Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    glyphName: "zero",
    horizAdvX: 646,
    d: "M53 547T115 645T323 743Q468 743 530 645T593 374Q593 200 531 101T323 2Q178 2 116 101T53 374Q53 547 115 645ZM455 448T446 498T408 581T323 613Q267 613 239 581T201 499T191 374Q191 298 200 247T238 164T323 132Q379 132 408 163T446 246T455 374Q455 448 446 498Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    glyphName: "one",
    horizAdvX: 362,
    d: "M36 600V729H277V0H133V600H36Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    glyphName: "two",
    horizAdvX: 574,
    d: "M97 158Q193 238 250 291T345 403T383 517Q383 568 359 597T285 626Q235 626 208 593T180 501H44Q48 621 115 683T287 745Q401 745 462 685T523 525Q523 447 481 376T385 253T244 126H539V10H45V114L97 158Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    glyphName: "three",
    horizAdvX: 599,
    d: "M60 637T125 691T298 746Q371 746 423 721T501 652T528 553Q528 490 496 447T418 388V384Q476 366 508 320T541 202Q541 142 514 95T433 22T304 -5Q191 -5 120 52T45 220H181Q183 171 214 142T301 112Q352 112 379 140T407 214Q407 274 369 300T251 326H222V441H251Q393 441 393 536Q393 579 368 603T294 627Q247 627 222 602T192 537H55Q60 637 125 691Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    glyphName: "four",
    horizAdvX: 661,
    d: "M47 142V252L374 720H537V264H625V142H537V0H397V142H47ZM406 570L201 264H406V570Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    glyphName: "five",
    horizAdvX: 644,
    d: "M543 608H219V437Q240 463 279 479T362 496Q442 496 493 461T567 372T590 255Q590 140 525 70T338 0Q224 0 156 57T79 206H215Q224 166 255 142T336 118Q395 118 425 155T455 253Q455 315 425 347T335 380Q293 380 265 359T225 303H91V731H543V608Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    glyphName: "six",
    horizAdvX: 640,
    d: "M421 589T397 610T326 631Q257 631 225 576T191 395Q215 435 261 457T361 480Q426 480 476 452T554 371T582 242Q582 171 554 116T470 29T339 -2Q235 -2 176 44T93 172T69 376Q69 559 132 652T331 746Q436 746 494 689T561 547H431Q421 589 397 610ZM276 365T240 334T204 244Q204 185 237 151T332 117Q386 117 417 150T449 239Q449 297 419 331T329 365Q276 365 240 334Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    glyphName: "seven",
    horizAdvX: 548,
    d: "M517 623L251 0H109L377 607H35V727H517V623Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    glyphName: "eight",
    horizAdvX: 643,
    d: "M75 438T75 547Q75 601 102 645T185 716T321 743Q401 743 456 717T539 646T567 547Q567 492 540 451T468 386Q523 362 554 316T585 207Q585 139 551 89T456 11T321 -16Q246 -16 187 11T93 88T58 207Q58 270 89 316T175 386Q75 438 75 547ZM431 576T402 603T321 630Q271 630 242 603T212 526Q212 481 242 454T321 427Q369 427 400 454T431 527Q431 576 402 603ZM264 325T229 296T193 213Q193 163 227 132T321 100Q380 100 414 132T448 213Q448 266 413 295T321 325Q264 325 229 296Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    glyphName: "nine",
    horizAdvX: 626,
    d: "M223 161T251 138T328 114Q390 114 418 165T446 339Q423 307 382 289T292 271Q228 271 177 297T95 376T65 504Q65 615 131 680T311 746Q453 746 511 655T570 381Q570 251 548 168T471 42T322 -1Q248 -1 196 27T117 102T85 205H215Q223 161 251 138ZM373 385T403 417T433 503Q433 562 402 594T316 627Q262 627 231 594T199 505Q199 452 229 419T321 385Q373 385 403 417Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    glyphName: "colon",
    horizAdvX: 263,
    d: "M93 -7T69 16T44 75Q44 110 68 133T131 157Q168 157 192 134T216 75Q216 40 192 17T131 -7Q93 -7 69 16ZM93 407T69 430T44 489Q44 524 68 547T131 571Q168 571 192 548T216 489Q216 454 192 431T131 407Q93 407 69 430Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    glyphName: "semicolon",
    horizAdvX: 324,
    d: "M118 403T94 426T69 485Q69 520 93 543T156 567Q193 567 217 544T241 485Q241 450 217 427T156 403Q118 403 94 426ZM248 147L131 -134H41L106 147H248Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    glyphName: "less",
    horizAdvX: 584,
    d: "M297 132L79 356L297 580H473L255 356L473 132H297Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    glyphName: "equal",
    horizAdvX: 738,
    d: "M641 537V415H96V537H641ZM641 297V175H96V297H641Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    glyphName: "greater",
    horizAdvX: 567,
    d: "M89 580H266L484 356L266 132H89L308 356L89 580Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    glyphName: "question",
    horizAdvX: 538,
    d: "M368 722T431 666T495 510Q495 412 432 361T265 309L261 232H138L133 402H178Q265 402 312 425T359 509Q359 553 334 579T264 605Q218 605 193 580T167 511H35Q34 572 61 620T140 695T264 722Q368 722 431 666ZM161 -7T137 16T112 75Q112 110 136 133T199 157Q236 157 260 134T284 75Q284 40 260 17T199 -7Q161 -7 137 16Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    glyphName: "at",
    horizAdvX: 1051,
    d: "M718 656T803 613T933 492T979 312Q979 230 951 157T868 39T740 -6Q688 -6 656 15T615 77Q586 38 540 16T443 -7Q367 -7 324 38T281 163Q281 238 312 303T398 407T522 447Q608 447 640 387L649 439H766L719 169Q716 150 716 134Q716 110 726 98T760 86Q796 86 820 120T857 205T870 307Q870 428 796 494T587 561Q472 561 379 506T234 355T181 142Q181 18 254 -49T463 -116Q560 -116 634 -81L654 -173Q559 -213 443 -213Q331 -213 247 -171T117 -50T71 131Q71 278 139 398T329 587T602 656Q718 656 803 613ZM523 97T553 118T600 174T618 249Q618 291 595 317T531 343Q494 343 466 321T423 262T407 186Q407 145 427 121T487 97Q523 97 553 118Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    glyphName: "A",
    horizAdvX: 716,
    d: "M497 133H219L173 0H26L277 699H440L691 0H543L497 133ZM459 245L358 537L257 245H459Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    glyphName: "B",
    horizAdvX: 643,
    d: "M524 347T562 299T600 189Q600 133 573 91T493 24T370 0H69V698H357Q428 698 479 675T557 611T584 518Q584 457 552 416T465 358Q524 347 562 299ZM209 410H337Q387 410 414 432T441 497Q441 539 414 562T337 585H209V410ZM401 114T429 138T458 206Q458 251 428 276T347 302H209V114H350Q401 114 429 138Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    glyphName: "C",
    horizAdvX: 768,
    d: "M35 453T81 534T208 661T389 707Q506 707 594 647T717 481H556Q532 531 489 556T388 581Q327 581 280 553T206 472T179 350Q179 281 205 229T279 148T388 119Q445 119 488 144T556 220H717Q682 113 595 54T389 -6Q289 -6 209 39T82 166T35 350Q35 453 81 534Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    glyphName: "D",
    horizAdvX: 717,
    d: "M423 698T506 655T635 533T681 348Q681 243 636 165T507 43T313 0H69V698H313Q423 698 506 655ZM418 119T478 179T538 348Q538 457 478 518T308 580H209V119H308Q418 119 478 179Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    glyphName: "E",
    horizAdvX: 532,
    d: "M209 585V410H444V299H209V114H474V0H69V699H474V585H209Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    glyphName: "F",
    horizAdvX: 530,
    d: "M500 698V585H209V406H432V295H209V0H69V698H500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    glyphName: "G",
    horizAdvX: 768,
    d: "M555 488Q531 532 489 555T391 578Q329 578 281 550T206 470T179 350Q179 280 206 228T283 148T397 120Q477 120 528 162T595 281H355V388H733V266Q719 193 673 131T555 32T392 -6Q291 -6 210 39T82 166T35 350Q35 453 81 534T209 661T391 707Q509 707 596 650T716 488H555Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    glyphName: "H",
    horizAdvX: 717,
    d: "M648 698V0H508V297H209V0H69V698H209V411H508V698H648Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    glyphName: "I",
    horizAdvX: 278,
    d: "M209 698V0H69V698H209Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    glyphName: "J",
    horizAdvX: 570,
    d: "M476 698V208Q476 106 417 50T259 -7Q159 -7 98 51T36 213H176Q177 168 197 143T257 118Q295 118 315 142T335 208V698H476Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    glyphName: "K",
    horizAdvX: 663,
    d: "M463 0L209 311V0H69V698H209V385L463 698H632L344 352L640 0H463Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    glyphName: "L",
    horizAdvX: 459,
    d: "M209 111H439V0H69V698H209V111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    glyphName: "M",
    horizAdvX: 899,
    d: "M830 698V0H690V454L503 0H397L209 454V0H69V698H228L450 179L672 698H830Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    glyphName: "N",
    horizAdvX: 735,
    d: "M666 0H526L209 479V0H69V699H209L526 219V699H666V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    glyphName: "O",
    horizAdvX: 785,
    d: "M295 -7T213 39T83 166T35 351Q35 453 83 534T213 662T393 708Q492 708 573 662T702 535T750 351Q750 248 703 167T573 39T393 -7Q295 -7 213 39ZM456 118T504 146T579 228T606 351Q606 421 579 473T504 554T393 582Q330 582 282 554T206 474T179 351Q179 281 206 228T281 147T393 118Q456 118 504 146Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    glyphName: "P",
    horizAdvX: 608,
    d: "M578 426T552 377T469 298T326 268H209V0H69V698H326Q407 698 464 670T549 593T578 482Q578 426 552 377ZM378 381T406 407T434 482Q434 584 320 584H209V381H320Q378 381 406 407Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    glyphName: "Q",
    horizAdvX: 787,
    d: "M589 -123L483 4Q439 -7 393 -7Q295 -7 213 39T83 166T35 351Q35 453 83 534T213 662T393 708Q492 708 573 662T702 535T750 351Q750 258 711 182T603 57L763 -123H589ZM179 281T206 228T281 147T393 118Q456 118 504 146T579 228T606 351Q606 421 579 473T504 554T393 582Q330 582 282 554T206 474T179 351Q179 281 206 228Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    glyphName: "R",
    horizAdvX: 641,
    d: "M429 0L275 272H209V0H69V698H331Q412 698 469 670T554 593T583 484Q583 415 543 360T424 283L591 0H429ZM209 377H326Q383 377 411 404T439 481Q439 529 411 555T326 582H209V377Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    glyphName: "S",
    horizAdvX: 609,
    d: "M237 -7T179 18T86 90T51 201H201Q204 158 231 133T307 108Q356 108 384 131T412 193Q412 224 393 244T346 275T267 301Q199 321 157 340T84 399T53 505Q53 567 84 613T171 683T299 708Q407 708 474 656T549 509H395Q393 545 365 568T289 592Q248 592 224 571T199 510Q199 482 217 464T263 434T341 407Q409 387 452 367T526 307T557 202Q557 146 528 98T443 22T310 -7Q237 -7 179 18Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    glyphName: "T",
    horizAdvX: 577,
    d: "M544 698V585H358V0H218V585H32V698H544Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    glyphName: "U",
    horizAdvX: 697,
    d: "M207 698V266Q207 195 244 158T348 120Q416 120 453 157T490 266V698H631V267Q631 178 593 117T490 24T346 -7Q268 -7 205 24T104 116T67 267V698H207Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    glyphName: "V",
    horizAdvX: 711,
    d: "M696 698L440 0H270L14 698H164L356 143L547 698H696Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    glyphName: "W",
    horizAdvX: 1024,
    d: "M1002 698L807 0H642L511 497L374 0L210 -1L22 698H172L295 156L437 698H593L727 159L851 698H1002Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    glyphName: "X",
    horizAdvX: 686,
    d: "M487 0L336 235L199 0H41L261 352L38 698H199L350 464L486 698H644L425 347L648 0H487Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    glyphName: "Y",
    horizAdvX: 636,
    d: "M624 698L388 243V0H248V243L11 698H169L319 379L468 698H624Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    glyphName: "Z",
    horizAdvX: 576,
    d: "M212 118H526V0H50V108L362 580H50V698H526V590L212 118Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    glyphName: "bracketleft",
    horizAdvX: 497,
    d: "M386 924V810H267V-81H386V-197H135V924H386Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    glyphName: "backslash",
    horizAdvX: 756,
    d: "M458 -181L173 947H309L595 -181H458Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    glyphName: "bracketright",
    horizAdvX: 496,
    d: "M361 -197H110V-81H229V810H110V924H361V-197Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    glyphName: "asciicircum",
    horizAdvX: 680,
    d: "M176 167H33L273 700H407L647 167H503L341 534L176 167Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    glyphName: "underscore",
    horizAdvX: 790,
    d: "M694 -40V-173H107V-40H694Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    glyphName: "grave",
    horizAdvX: 271,
    d: "M240 693V593L10 698V812L240 693Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    glyphName: "a",
    horizAdvX: 678,
    d: "M33 363T66 428T157 528T286 563Q348 563 394 538T469 475V554H610V0H469V81Q442 42 395 17T285 -9Q215 -9 158 27T67 128T33 279Q33 363 66 428ZM469 328T449 364T395 420T322 440Q283 440 250 421T197 366T176 279Q176 229 196 192T250 134T322 114Q361 114 395 133T449 189T469 277Q469 328 449 364Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    glyphName: "b",
    horizAdvX: 678,
    d: "M236 513T283 538T392 563Q463 563 520 528T611 429T645 279Q645 194 612 129T521 27T392 -9Q330 -9 284 15T209 79V0H69V740H209V473Q236 513 283 538ZM502 329T482 365T428 421T355 440Q317 440 284 421T230 364T209 277Q209 227 229 190T283 134T355 114Q394 114 427 134T481 191T502 279Q502 329 482 365Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    glyphName: "c",
    horizAdvX: 602,
    d: "M33 363T68 427T165 527T307 563Q410 563 477 512T568 367H417Q405 403 377 423T306 444Q246 444 211 401T176 277Q176 198 211 155T306 111Q391 111 417 187H568Q545 97 477 44T307 -9Q227 -9 165 26T68 126T33 277Q33 363 68 427Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    glyphName: "d",
    horizAdvX: 678,
    d: "M33 363T66 428T158 528T287 563Q341 563 390 540T468 477V740H610V0H468V82Q442 41 395 16T286 -9Q216 -9 158 27T67 128T33 279Q33 363 66 428ZM469 328T449 364T395 420T322 440Q283 440 250 421T197 366T176 279Q176 229 196 192T250 134T322 114Q361 114 395 133T449 189T469 277Q469 328 449 364Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    glyphName: "e",
    horizAdvX: 617,
    d: "M584 259T580 235H175Q180 175 217 141T308 107Q386 107 419 174H570Q546 94 478 43T311 -9Q231 -9 168 26T69 127T33 277Q33 363 68 428T166 528T311 563Q390 563 452 529T549 433T584 289Q584 259 580 235ZM439 329Q438 383 400 415T307 448Q255 448 220 417T176 329H439Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    glyphName: "f",
    horizAdvX: 345,
    d: "M323 439H226V0H84V439H21V554H84V582Q84 684 142 732T317 777V659Q266 660 246 642T226 577V554H323V439Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    glyphName: "g",
    horizAdvX: 678,
    d: "M348 563T395 539T469 475V554H610V-4Q610 -81 579 -141T486 -237T336 -273Q218 -273 143 -218T57 -68H196Q207 -106 243 -128T332 -151Q393 -151 431 -115T469 -4V82Q442 43 395 17T286 -9Q216 -9 158 27T67 128T33 279Q33 363 66 428T157 528T286 563Q348 563 395 539ZM469 328T449 364T395 420T322 440Q283 440 250 421T197 366T176 279Q176 229 196 192T250 134T322 114Q361 114 395 133T449 189T469 277Q469 328 449 364Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    glyphName: "h",
    horizAdvX: 661,
    d: "M444 562T493 535T569 454T597 325V0H457V306Q457 372 424 407T334 443Q276 443 243 408T209 306V0H69V740H209V485Q236 521 281 541T381 562Q444 562 493 535Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    glyphName: "i",
    horizAdvX: 278,
    d: "M103 620T79 643T54 702Q54 737 78 760T140 784Q177 784 201 761T226 702Q226 667 202 644T140 620Q103 620 79 643ZM209 554V0H69V554H209Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    glyphName: "j",
    horizAdvX: 278,
    d: "M102 620T78 643T53 702Q53 737 77 760T140 784Q177 784 201 761T225 702Q225 667 201 644T140 620Q102 620 78 643ZM209 -91Q209 -183 164 -223T33 -264H-29V-145H11Q43 -145 56 -133T69 -92V554H209V-91Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    glyphName: "k",
    horizAdvX: 584,
    d: "M397 0L209 236V0H69V740H209V319L395 554H577L333 276L579 0H397Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    glyphName: "l",
    horizAdvX: 278,
    d: "M209 740V0H69V740H209Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    glyphName: "m",
    horizAdvX: 1048,
    d: "M859 562T921 500T984 325V0H844V306Q844 371 811 405T721 440Q664 440 631 406T597 306V0H457V306Q457 371 424 405T334 440Q276 440 243 406T209 306V0H69V554H209V487Q236 522 278 542T372 562Q437 562 488 535T567 456Q594 504 645 533T757 562Q859 562 921 500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    glyphName: "n",
    horizAdvX: 661,
    d: "M475 562T536 500T597 325V0H457V306Q457 372 424 407T334 443Q276 443 243 408T209 306V0H69V554H209V485Q237 521 280 541T376 562Q475 562 536 500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    glyphName: "o",
    horizAdvX: 638,
    d: "M235 -9T171 26T71 127T34 277Q34 362 71 427T174 527T319 563Q399 563 464 528T566 427T604 277Q604 192 566 127T462 27T315 -9Q235 -9 171 26ZM353 113T386 131T440 187T460 277Q460 356 419 398T317 441Q257 441 217 399T176 277Q176 198 215 156T315 113Q353 113 386 131Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    glyphName: "p",
    horizAdvX: 678,
    d: "M236 512T283 537T392 563Q463 563 520 528T611 429T645 279Q645 194 612 129T521 27T392 -9Q331 -9 285 16T209 79V-264H69V554H209V474Q236 512 283 537ZM502 329T482 365T428 421T355 440Q317 440 284 421T230 364T209 277Q209 227 229 190T283 134T355 114Q394 114 427 134T481 191T502 279Q502 329 482 365Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    glyphName: "q",
    horizAdvX: 678,
    d: "M33 361T67 425T161 526T291 562Q350 562 395 540T469 482V554H610V-264H469V76Q441 40 394 16T288 -8Q218 -8 160 28T67 130T33 278Q33 361 67 425ZM469 328T448 365T394 421T322 440Q285 440 252 421T197 366T176 278Q176 227 197 190T251 133T322 114Q360 114 393 133T448 189T469 277Q469 328 448 365Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    glyphName: "r",
    horizAdvX: 404,
    d: "M236 512T279 537T379 562V415H342Q276 415 243 384T209 276V0H69V554H209V468Q236 512 279 537Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    glyphName: "s",
    horizAdvX: 545,
    d: "M213 -9T159 15T74 82T39 175H180Q184 143 211 122T280 101Q320 101 342 117T365 158Q365 185 338 198T250 228Q188 243 149 259T81 308T52 397Q52 443 78 481T154 541T271 563Q370 563 429 514T494 380H360Q357 413 333 432T267 452Q229 452 209 438T188 399Q188 371 216 357T303 327Q363 312 402 296T469 247T499 158Q499 110 473 72T397 13T281 -9Q213 -9 159 15Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    glyphName: "t",
    horizAdvX: 388,
    d: "M232 439V171Q232 143 245 131T291 118H356V0H268Q91 0 91 172V439H25V554H91V691H232V554H356V439H232Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    glyphName: "u",
    horizAdvX: 661,
    d: "M592 554V0H451V70Q424 34 381 14T286 -7Q221 -7 171 20T93 101T64 229V554H204V249Q204 183 237 148T327 112Q385 112 418 147T451 249V554H592Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    glyphName: "v",
    horizAdvX: 599,
    d: "M300 129L440 554H589L384 0H214L10 554H160L300 129Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    glyphName: "w",
    horizAdvX: 844,
    d: "M837 554L675 0H524L423 387L322 0H170L7 554H149L247 132L353 554H501L605 133L703 554H837Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    glyphName: "x",
    horizAdvX: 540,
    d: "M375 0L261 172L160 0H10L191 278L8 554H166L279 383L381 554H531L349 278L533 0H375Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    glyphName: "y",
    horizAdvX: 605,
    d: "M599 554L256 -262H107L227 14L5 554H162L305 167L450 554H599Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    glyphName: "z",
    horizAdvX: 483,
    d: "M197 115H444V0H38V113L280 439H39V554H441V441L197 115Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    glyphName: "braceleft",
    horizAdvX: 508,
    d: "M110 418Q158 422 182 444T207 503Q207 545 198 624Q188 718 188 761Q188 839 234 882T358 926H427V808H385Q323 808 323 749Q323 721 331 637Q332 627 336 581T340 498Q340 445 314 410T235 365V363Q288 352 314 318T340 229Q340 195 336 149T331 90Q323 6 323 -21Q323 -52 338 -66T385 -80H427V-199H358Q281 -199 235 -156T188 -34Q188 10 198 104Q207 183 207 224Q207 261 183 283T110 309V418Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    glyphName: "bar",
    horizAdvX: 309,
    d: "M225 -121H84V808H225V-121Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    glyphName: "braceright",
    horizAdvX: 508,
    d: "M350 305T326 283T301 224Q301 183 310 104Q320 10 320 -34Q320 -112 274 -155T150 -199H81V-80H123Q155 -80 170 -66T185 -21Q185 6 177 90Q176 102 172 148T168 229Q168 283 194 317T273 363V365Q220 375 194 410T168 498Q168 534 172 580T177 637Q185 721 185 749Q185 808 123 808H81V926H150Q227 926 273 883T320 761Q320 718 310 624Q301 545 301 503Q301 466 325 444T398 418V309Q350 305 326 283Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    glyphName: "asciitilde",
    horizAdvX: 592,
    d: "M49 321T95 367T210 413Q240 413 264 404T317 376Q340 362 356 355T391 348Q417 348 434 364T456 412H560Q543 315 497 269T381 223Q351 223 328 232T275 260Q250 274 235 281T201 288Q175 288 157 272T134 224H32Q49 321 95 367Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    glyphName: "uni00A0",
    horizAdvX: 238
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    glyphName: "exclamdown",
    horizAdvX: 354,
    d: "M215 569T239 546T263 487Q263 452 239 429T178 405Q140 405 116 428T91 487Q91 522 115 545T178 569Q215 569 239 546ZM116 335H234L250 -148H99L116 335Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    glyphName: "cent",
    horizAdvX: 663,
    d: "M367 111T395 129T434 182H564Q557 106 499 56T352 -2V-87H288V-2Q177 8 116 79T55 258Q55 366 116 437T288 518V603H352V518Q440 510 498 460T564 334H434Q411 405 322 405Q260 405 224 366T188 258Q188 189 224 150T322 111Q367 111 395 129Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    glyphName: "sterling",
    horizAdvX: 654,
    d: "M572 109V-3H87L65 69Q110 113 131 158T152 272Q152 279 150 295H39V391H122Q102 459 102 514Q102 582 131 631T214 707T336 733Q447 733 505 672T567 514H438Q437 562 413 589T338 617Q291 617 264 589T236 503Q236 477 241 452T258 391H446V295H283Q285 279 285 271Q285 228 269 186T218 109H572Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    glyphName: "currency",
    horizAdvX: 561,
    d: "M478 318T445 272L501 216L444 158L381 220Q335 198 280 198Q224 198 180 220L118 158L60 216L117 273Q86 316 86 377Q86 438 118 483L60 541L118 599L182 535Q224 556 281 556Q338 556 380 535L444 599L501 541L445 484Q478 440 478 377Q478 318 445 272ZM315 282T339 307T364 377Q364 423 340 448T281 473Q246 473 222 448T198 377Q198 331 221 307T280 282Q315 282 339 307Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    glyphName: "yen",
    horizAdvX: 636,
    d: "M474 409H588V312L423 310L388 243V234H588V137H388V0H248V137H48V234H248V243L213 311L48 312V409H162L11 698H169L318 372L466 698H624L474 409Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    glyphName: "brokenbar",
    horizAdvX: 350,
    d: "M105 808H245V409H105V808ZM245 -121H105V278H245V-121Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    glyphName: "section",
    horizAdvX: 582,
    d: "M512 35T512 -46Q512 -94 486 -133T409 -195T290 -218Q193 -218 134 -171T73 -42H213Q219 -120 291 -120Q329 -120 350 -104T371 -56Q371 -34 358 -18T312 15T216 57Q125 93 81 136T36 244Q36 296 64 336T150 399Q70 453 70 534Q70 582 96 621T173 683T292 706Q389 706 448 659T509 530H369Q367 568 348 588T291 608Q253 608 232 592T211 544Q211 522 224 506T270 473T366 431Q457 395 501 352T546 244Q546 139 432 89Q512 35 512 -46ZM183 205T213 179T292 152Q341 152 370 178T400 244Q400 283 370 309T291 336Q242 336 213 310T183 244Q183 205 213 179Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    glyphName: "dieresis",
    horizAdvX: 338,
    d: "M48 620T29 639T10 686Q10 714 29 733T76 753Q104 753 123 734T143 686Q143 658 124 639T76 620Q48 620 29 639ZM233 620T214 639T195 686Q195 714 214 733T261 753Q289 753 308 734T328 686Q328 658 309 639T261 620Q233 620 214 639Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    glyphName: "copyright",
    horizAdvX: 785,
    d: "M495 708T574 663T698 536T743 350Q743 246 699 165T575 38T393 -8Q290 -8 211 37T87 164T42 350Q42 454 86 535T210 662T393 708Q495 708 574 663ZM303 657T236 620T133 513T97 350Q97 258 133 189T236 81T393 42Q482 42 549 80T652 188T688 350Q688 443 652 512T550 619T393 657Q303 657 236 620ZM329 578T279 550T201 471T172 351Q172 283 200 231T279 151T392 123Q469 123 525 165T598 278H475Q464 250 444 235T389 220Q343 220 317 253T290 351Q290 415 316 448T389 481Q421 481 443 466T475 423H598Q581 495 526 536T392 578Q329 578 279 550Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    glyphName: "ordfeminine",
    horizAdvX: 462,
    d: "M28 583T50 624T111 687T195 710Q277 710 318 658V704H426V353H318V398Q300 375 270 362T198 348Q151 348 112 371T51 435T28 530Q28 583 50 624ZM139 484T165 458T229 432Q266 432 292 458T318 529Q318 574 292 600T229 626Q192 626 166 600T139 529Q139 484 165 458Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    glyphName: "guillemotleft",
    horizAdvX: 521,
    d: "M133 120L45 295L133 470H266L174 295L266 120H133ZM341 120L252 295L341 470H473L381 295L473 120H341Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    glyphName: "logicalnot",
    horizAdvX: 681,
    d: "M631 438V195H491V330H41V438H631Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    glyphName: "uni00AD",
    horizAdvX: 583,
    d: "M495 416V298H71V416H495Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    glyphName: "registered",
    horizAdvX: 516,
    d: "M319 709T367 682T443 607T470 496Q470 435 443 387T368 312T258 284Q197 284 149 311T73 387T45 496Q45 558 72 606T148 682T258 709Q319 709 367 682ZM330 335T373 379T417 496Q417 569 374 613T258 658Q186 658 143 614T100 496Q100 423 143 379T258 335Q330 335 373 379ZM352 514T342 498T312 474L364 392H286L243 467H237V392H170V606H275Q310 606 331 587T352 536Q352 514 342 498ZM236 517H268Q275 517 280 521T285 533Q285 548 268 548H236V517Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    glyphName: "overscore",
    horizAdvX: 402,
    d: "M392 732V632H10V732H392Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    glyphName: "degree",
    horizAdvX: 444,
    d: "M27 609T81 657T223 705Q309 705 363 657T417 527Q417 445 363 396T221 347Q135 347 81 396T27 527Q27 609 81 657ZM307 575T282 601T221 628Q186 628 161 602T136 526Q136 478 160 452T221 426Q256 426 281 452T307 526Q307 575 282 601Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    glyphName: "plusminus",
    horizAdvX: 676,
    d: "M405 365V241H593V119H83V241H272V365H83V487H272V623H405V487H593V365H405Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    glyphName: "twosuperior",
    horizAdvX: 360,
    d: "M149 437H321V352H34V432L148 509Q179 530 194 550T210 593Q210 611 200 622T174 633Q143 633 138 596H30Q33 648 73 680T182 712Q226 712 258 696T306 655T323 600Q323 564 299 537T218 476L149 437Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    glyphName: "threesuperior",
    horizAdvX: 357,
    d: "M24 650T64 681T177 712Q240 712 281 682T323 607Q323 577 306 558T259 531V528Q291 519 309 498T328 447Q328 403 285 375T175 347Q101 347 61 378T17 463H125Q131 425 170 425Q189 425 201 435T213 464Q213 482 200 492T165 503H130V560H161Q208 560 208 598Q208 615 197 624T167 634Q130 634 124 601H22Q24 650 64 681Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    glyphName: "acute",
    horizAdvX: 250,
    d: "M240 698L10 593V693L240 812V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    glyphName: "uni00B5",
    horizAdvX: 678,
    d: "M603 554V0H462V85Q436 41 392 17T289 -7Q245 -7 214 12V-264H75V554H214V249Q214 184 247 149T338 114Q395 114 428 149T462 249V554H603Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    glyphName: "paragraph",
    horizAdvX: 666,
    d: "M591 0H472V590H407V0H287V278H269Q151 278 92 337T32 488Q32 546 57 593T136 669T269 698H591V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    glyphName: "middot",
    horizAdvX: 270,
    d: "M100 244T76 267T51 326Q51 361 75 384T138 408Q175 408 199 385T223 326Q223 291 199 268T138 244Q100 244 76 267Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    glyphName: "cedilla",
    horizAdvX: 295,
    d: "M210 -43T247 -71T285 -152Q285 -206 247 -235T152 -264H10V-182H129Q153 -182 165 -175T178 -150Q178 -132 166 -126T129 -119H67V7H155V-43Q210 -43 247 -71Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    glyphName: "onesuperior",
    horizAdvX: 228,
    d: "M20 622V704H184V352H77V622H20Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    glyphName: "ordmasculine",
    horizAdvX: 450,
    d: "M28 582T53 623T123 686T225 709Q282 709 327 687T397 623T422 528Q422 475 397 434T326 370T224 347Q167 347 123 370T53 434T28 528Q28 582 53 623ZM312 574T287 600T224 626Q188 626 164 600T139 527Q139 482 163 457T224 431Q260 431 286 456T312 527Q312 574 287 600Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    glyphName: "guillemotright",
    horizAdvX: 521,
    d: "M141 295L50 470H182L271 295L182 120H50L141 295ZM349 295L257 470H389L478 295L389 120H257L349 295Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    glyphName: "onequarter",
    horizAdvX: 730,
    d: "M37 622V704H201V352H94V622H37ZM592 699L209 0H75L459 699H592ZM695 65H653V0H545V65H355V123L504 353H653V129H695V65ZM549 276L460 130H549V276Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    glyphName: "onehalf",
    horizAdvX: 757,
    d: "M94 622H37V704H201V352H94V622ZM587 700L209 0H75L452 700H587ZM531 84H703V-1H416V79L530 156Q561 177 576 197T592 240Q592 258 582 269T556 280Q525 280 520 243H412Q415 295 455 327T564 359Q608 359 640 343T688 302T705 247Q705 211 681 184T600 123L531 84Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    glyphName: "threequarters",
    horizAdvX: 811,
    d: "M48 650T88 681T201 712Q264 712 305 682T347 607Q347 577 330 558T283 531V528Q315 519 333 498T352 447Q352 403 309 375T199 347Q125 347 85 378T41 463H149Q155 425 194 425Q213 425 225 435T237 464Q237 482 224 492T189 503H154V560H185Q232 560 232 598Q232 615 221 624T191 634Q154 634 148 601H46Q48 650 88 681ZM697 700L303 0H169L563 700H697ZM788 65H745V0H638V65H448V123L591 353H745V129H788V65ZM642 281L552 129H642V281Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    glyphName: "questiondown",
    horizAdvX: 538,
    d: "M377 566T401 543T426 484Q426 449 402 426T339 402Q302 402 278 425T254 484Q254 519 278 542T339 566Q377 566 401 543ZM170 -163T107 -107T43 49Q43 147 106 198T273 250L277 327H400L405 157H360Q272 157 225 134T179 48Q179 4 204 -21T274 -46Q320 -46 345 -21T371 48H503Q504 -13 477 -61T398 -136T274 -163Q170 -163 107 -107Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    glyphName: "Agrave",
    horizAdvX: 716,
    d: "M497 133H219L173 0H26L277 699H440L691 0H543L497 133ZM459 245L358 537L257 245H459ZM467 838V738L237 843V957L467 838Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    glyphName: "Aacute",
    horizAdvX: 716,
    d: "M497 133H219L173 0H26L277 699H440L691 0H543L497 133ZM459 245L358 537L257 245H459ZM467 843L237 738V838L467 957V843Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    glyphName: "Acircumflex",
    horizAdvX: 716,
    d: "M497 133H219L173 0H26L277 699H440L691 0H543L497 133ZM459 245L358 537L257 245H459ZM359 822L210 738V840L359 921L507 840V738L359 822Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    glyphName: "Atilde",
    horizAdvX: 716,
    d: "M497 133H219L173 0H26L277 699H440L691 0H543L497 133ZM459 245L358 537L257 245H459ZM187 818T219 850T302 883Q323 883 339 877T375 858Q405 839 425 839Q462 839 468 882H543Q534 816 502 784T419 751Q398 751 382 757T346 776Q317 796 296 796Q259 796 252 752H178Q187 818 219 850Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    glyphName: "Adieresis",
    horizAdvX: 716,
    d: "M497 133H219L173 0H26L277 699H440L691 0H543L497 133ZM459 245L358 537L257 245H459ZM237 765T218 784T199 831Q199 859 218 878T265 898Q293 898 312 879T332 831Q332 803 313 784T265 765Q237 765 218 784ZM422 765T403 784T384 831Q384 859 403 878T450 898Q478 898 497 879T517 831Q517 803 498 784T450 765Q422 765 403 784Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    glyphName: "Aring",
    horizAdvX: 716,
    d: "M497 133H219L173 0H26L277 699H440L691 0H543L497 133ZM459 245L358 537L257 245H459ZM476 810T443 779T359 747Q310 747 276 778T242 862Q242 914 276 945T359 977Q409 977 442 946T476 862Q476 810 443 779ZM407 885T393 898T359 912Q339 912 325 899T311 862Q311 841 325 827T359 812Q379 812 393 826T407 862Q407 885 393 898Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    glyphName: "AE",
    horizAdvX: 937,
    d: "M617 589V409H849V301H617V111H879V0H476V131H231L162 0H9L381 699H879V589H617ZM476 239V597L288 239H476Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    glyphName: "Ccedilla",
    horizAdvX: 768,
    d: "M445 119T488 144T556 220H717Q686 124 611 66T433 -4V-45Q488 -45 525 -73T563 -154Q563 -208 525 -237T430 -266H288V-184H407Q431 -184 443 -177T456 -152Q456 -134 444 -128T407 -121H345V-4Q256 6 186 53T75 178T35 350Q35 453 81 534T208 661T389 707Q506 707 594 647T717 481H556Q532 531 489 556T388 581Q327 581 280 553T206 472T179 350Q179 281 205 229T279 148T388 119Q445 119 488 144Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    glyphName: "Egrave",
    horizAdvX: 532,
    d: "M209 585V410H444V299H209V114H474V0H69V699H474V585H209ZM376 838V738L146 843V957L376 838Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    glyphName: "Eacute",
    horizAdvX: 532,
    d: "M209 585V410H444V299H209V114H474V0H69V699H474V585H209ZM376 843L146 738V838L376 957V843Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    glyphName: "Ecircumflex",
    horizAdvX: 532,
    d: "M209 585V410H444V299H209V114H474V0H69V699H474V585H209ZM267 822L118 738V840L267 921L415 840V738L267 822Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    glyphName: "Edieresis",
    horizAdvX: 532,
    d: "M209 585V410H444V299H209V114H474V0H69V699H474V585H209ZM146 765T127 784T108 831Q108 859 127 878T174 898Q202 898 221 879T241 831Q241 803 222 784T174 765Q146 765 127 784ZM331 765T312 784T293 831Q293 859 312 878T359 898Q387 898 406 879T426 831Q426 803 407 784T359 765Q331 765 312 784Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    glyphName: "Igrave",
    horizAdvX: 278,
    d: "M209 698V0H69V698H209ZM248 838V738L18 843V957L248 838Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    glyphName: "Iacute",
    horizAdvX: 278,
    d: "M209 698V0H69V698H209ZM248 843L18 738V838L248 957V843Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    glyphName: "Icircumflex",
    horizAdvX: 278,
    d: "M209 698V0H69V698H209ZM140 822L-9 738V840L140 921L288 840V738L140 822Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    glyphName: "Idieresis",
    horizAdvX: 278,
    d: "M209 698V0H69V698H209ZM18 765T-1 784T-20 831Q-20 859 -1 878T46 898Q74 898 93 879T113 831Q113 803 94 784T46 765Q18 765 -1 784ZM203 765T184 784T165 831Q165 859 184 878T231 898Q259 898 278 879T298 831Q298 803 279 784T231 765Q203 765 184 784Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    glyphName: "Eth",
    horizAdvX: 726,
    d: "M432 698T515 655T644 533T690 348Q690 243 645 165T516 43T322 0H77V287H7V409H77V698H322Q432 698 515 655ZM426 114T486 176T546 348Q546 458 486 519T317 581H218V409H385V287H218V114H317Q426 114 486 176Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    glyphName: "Ntilde",
    horizAdvX: 735,
    d: "M666 0H526L209 479V0H69V699H209L526 219V699H666V0ZM197 818T229 850T312 883Q333 883 349 877T385 858Q415 839 435 839Q472 839 478 882H553Q544 816 512 784T429 751Q408 751 392 757T356 776Q327 796 306 796Q269 796 262 752H188Q197 818 229 850Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    glyphName: "Ograve",
    horizAdvX: 785,
    d: "M295 -7T213 39T83 166T35 351Q35 453 83 534T213 662T393 708Q492 708 573 662T702 535T750 351Q750 248 703 167T573 39T393 -7Q295 -7 213 39ZM456 118T504 146T579 228T606 351Q606 421 579 473T504 554T393 582Q330 582 282 554T206 474T179 351Q179 281 206 228T281 147T393 118Q456 118 504 146ZM502 838V738L272 843V957L502 838Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    glyphName: "Oacute",
    horizAdvX: 785,
    d: "M295 -7T213 39T83 166T35 351Q35 453 83 534T213 662T393 708Q492 708 573 662T702 535T750 351Q750 248 703 167T573 39T393 -7Q295 -7 213 39ZM456 118T504 146T579 228T606 351Q606 421 579 473T504 554T393 582Q330 582 282 554T206 474T179 351Q179 281 206 228T281 147T393 118Q456 118 504 146ZM502 843L272 738V838L502 957V843Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    glyphName: "Ocircumflex",
    horizAdvX: 785,
    d: "M295 -7T213 39T83 166T35 351Q35 453 83 534T213 662T393 708Q492 708 573 662T702 535T750 351Q750 248 703 167T573 39T393 -7Q295 -7 213 39ZM456 118T504 146T579 228T606 351Q606 421 579 473T504 554T393 582Q330 582 282 554T206 474T179 351Q179 281 206 228T281 147T393 118Q456 118 504 146ZM393 822L244 738V840L393 921L541 840V738L393 822Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    glyphName: "Otilde",
    horizAdvX: 785,
    d: "M295 -7T213 39T83 166T35 351Q35 453 83 534T213 662T393 708Q492 708 573 662T702 535T750 351Q750 248 703 167T573 39T393 -7Q295 -7 213 39ZM456 118T504 146T579 228T606 351Q606 421 579 473T504 554T393 582Q330 582 282 554T206 474T179 351Q179 281 206 228T281 147T393 118Q456 118 504 146ZM222 818T254 850T337 883Q358 883 374 877T410 858Q440 839 460 839Q497 839 503 882H578Q569 816 537 784T454 751Q433 751 417 757T381 776Q352 796 331 796Q294 796 287 752H213Q222 818 254 850Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    glyphName: "Odieresis",
    horizAdvX: 785,
    d: "M295 -7T213 39T83 166T35 351Q35 453 83 534T213 662T393 708Q492 708 573 662T702 535T750 351Q750 248 703 167T573 39T393 -7Q295 -7 213 39ZM456 118T504 146T579 228T606 351Q606 421 579 473T504 554T393 582Q330 582 282 554T206 474T179 351Q179 281 206 228T281 147T393 118Q456 118 504 146ZM272 765T253 784T234 831Q234 859 253 878T300 898Q328 898 347 879T367 831Q367 803 348 784T300 765Q272 765 253 784ZM457 765T438 784T419 831Q419 859 438 878T485 898Q513 898 532 879T552 831Q552 803 533 784T485 765Q457 765 438 784Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    glyphName: "multiply",
    horizAdvX: 670,
    d: "M480 123L334 269L189 124L98 215L243 361L102 502L193 593L334 452L475 593L567 502L426 361L572 214L480 123Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    glyphName: "Oslash",
    horizAdvX: 785,
    d: "M662 591Q704 544 727 483T750 351Q750 248 703 167T573 39T393 -7Q333 -7 278 11T177 62L121 0H24L124 110Q82 158 59 219T35 351Q35 453 83 534T213 662T393 708Q453 708 508 691T609 640L664 700H761L662 591ZM179 269T216 210L520 543Q467 582 393 582Q330 582 282 554T206 474T179 351Q179 269 216 210ZM606 433T569 490L265 157Q320 118 393 118Q456 118 504 146T579 228T606 351Q606 433 569 490Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    glyphName: "Ugrave",
    horizAdvX: 697,
    d: "M207 698V266Q207 195 244 158T348 120Q416 120 453 157T490 266V698H631V267Q631 178 593 117T490 24T346 -7Q268 -7 205 24T104 116T67 267V698H207ZM457 838V738L227 843V957L457 838Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    glyphName: "Uacute",
    horizAdvX: 697,
    d: "M207 698V266Q207 195 244 158T348 120Q416 120 453 157T490 266V698H631V267Q631 178 593 117T490 24T346 -7Q268 -7 205 24T104 116T67 267V698H207ZM457 843L227 738V838L457 957V843Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    glyphName: "Ucircumflex",
    horizAdvX: 697,
    d: "M207 698V266Q207 195 244 158T348 120Q416 120 453 157T490 266V698H631V267Q631 178 593 117T490 24T346 -7Q268 -7 205 24T104 116T67 267V698H207ZM349 822L200 738V840L349 921L497 840V738L349 822Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    glyphName: "Udieresis",
    horizAdvX: 697,
    d: "M207 698V266Q207 195 244 158T348 120Q416 120 453 157T490 266V698H631V267Q631 178 593 117T490 24T346 -7Q268 -7 205 24T104 116T67 267V698H207ZM228 765T209 784T190 831Q190 859 209 878T256 898Q284 898 303 879T323 831Q323 803 304 784T256 765Q228 765 209 784ZM413 765T394 784T375 831Q375 859 394 878T441 898Q469 898 488 879T508 831Q508 803 489 784T441 765Q413 765 394 784Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    glyphName: "Yacute",
    horizAdvX: 636,
    d: "M624 698L388 243V0H248V243L11 698H169L319 379L468 698H624ZM427 843L197 738V838L427 957V843Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    glyphName: "Thorn",
    horizAdvX: 608,
    d: "M578 294T552 246T469 168T326 138H209V0H69V699H208V563H326Q407 563 464 535T549 459T578 350Q578 294 552 246ZM377 245T405 273T434 350Q434 399 406 427T320 455H209V245H320Q377 245 405 273Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    glyphName: "germandbls",
    horizAdvX: 727,
    d: "M52 613T82 663T171 742T316 771Q390 771 445 747T528 682T557 594Q557 545 535 513T474 445Q453 426 444 415T434 392Q434 375 453 362T532 328Q608 301 642 262T676 161Q676 84 620 37T467 -10Q372 -10 314 39T245 177H380Q383 139 405 118T465 96Q500 96 518 110T537 152Q537 180 519 197T450 232Q366 261 330 292T293 370Q293 403 310 429T361 487Q390 516 403 535T417 577Q417 613 389 633T311 654Q249 654 221 624T192 535V0H52V549Q52 613 82 663Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    glyphName: "agrave",
    horizAdvX: 678,
    d: "M33 363T66 428T157 528T286 563Q348 563 394 538T469 475V554H610V0H469V81Q442 42 395 17T285 -9Q215 -9 158 27T67 128T33 279Q33 363 66 428ZM469 328T449 364T395 420T322 440Q283 440 250 421T197 366T176 279Q176 229 196 192T250 134T322 114Q361 114 395 133T449 189T469 277Q469 328 449 364ZM450 693V593L220 698V812L450 693Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    glyphName: "aacute",
    horizAdvX: 678,
    d: "M33 363T66 428T157 528T286 563Q348 563 394 538T469 475V554H610V0H469V81Q442 42 395 17T285 -9Q215 -9 158 27T67 128T33 279Q33 363 66 428ZM469 328T449 364T395 420T322 440Q283 440 250 421T197 366T176 279Q176 229 196 192T250 134T322 114Q361 114 395 133T449 189T469 277Q469 328 449 364ZM450 698L220 593V693L450 812V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    glyphName: "acircumflex",
    horizAdvX: 678,
    d: "M33 363T66 428T157 528T286 563Q348 563 394 538T469 475V554H610V0H469V81Q442 42 395 17T285 -9Q215 -9 158 27T67 128T33 279Q33 363 66 428ZM469 328T449 364T395 420T322 440Q283 440 250 421T197 366T176 279Q176 229 196 192T250 134T322 114Q361 114 395 133T449 189T469 277Q469 328 449 364ZM341 677L192 593V695L341 776L489 695V593L341 677Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    glyphName: "atilde",
    horizAdvX: 678,
    d: "M33 363T66 428T157 528T286 563Q348 563 394 538T469 475V554H610V0H469V81Q442 42 395 17T285 -9Q215 -9 158 27T67 128T33 279Q33 363 66 428ZM469 328T449 364T395 420T322 440Q283 440 250 421T197 366T176 279Q176 229 196 192T250 134T322 114Q361 114 395 133T449 189T469 277Q469 328 449 364ZM170 673T202 705T285 738Q306 738 322 732T358 713Q388 694 408 694Q445 694 451 737H526Q517 671 485 639T402 606Q381 606 365 612T329 631Q300 651 279 651Q242 651 235 607H161Q170 673 202 705Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    glyphName: "adieresis",
    horizAdvX: 678,
    d: "M33 363T66 428T157 528T286 563Q348 563 394 538T469 475V554H610V0H469V81Q442 42 395 17T285 -9Q215 -9 158 27T67 128T33 279Q33 363 66 428ZM469 328T449 364T395 420T322 440Q283 440 250 421T197 366T176 279Q176 229 196 192T250 134T322 114Q361 114 395 133T449 189T469 277Q469 328 449 364ZM220 620T201 639T182 686Q182 714 201 733T248 753Q276 753 295 734T315 686Q315 658 296 639T248 620Q220 620 201 639ZM405 620T386 639T367 686Q367 714 386 733T433 753Q461 753 480 734T500 686Q500 658 481 639T433 620Q405 620 386 639Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    glyphName: "aring",
    horizAdvX: 678,
    d: "M33 363T66 428T157 528T286 563Q348 563 394 538T469 475V554H610V0H469V81Q442 42 395 17T285 -9Q215 -9 158 27T67 128T33 279Q33 363 66 428ZM469 328T449 364T395 420T322 440Q283 440 250 421T197 366T176 279Q176 229 196 192T250 134T322 114Q361 114 395 133T449 189T469 277Q469 328 449 364ZM458 665T425 634T341 602Q292 602 258 633T224 717Q224 769 258 800T341 832Q391 832 424 801T458 717Q458 665 425 634ZM389 740T375 753T341 767Q321 767 307 754T293 717Q293 696 307 682T341 667Q361 667 375 681T389 717Q389 740 375 753Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    glyphName: "ae",
    horizAdvX: 1077,
    d: "M1045 268T1040 238H613Q621 175 662 141T756 107Q804 107 835 125T879 174H1030Q1007 94 944 43T791 -9Q730 -9 680 16T600 82V0H472V82Q441 41 393 16T286 -9Q216 -9 158 27T67 128T33 279Q33 364 66 428T159 528T291 563Q407 563 474 476V554H600V476Q636 521 683 542T791 563Q865 563 922 529T1012 432T1045 290Q1045 268 1040 238ZM900 323Q899 380 859 414T759 448Q704 448 664 415T613 323H900ZM361 114T395 133T449 189T469 277Q469 328 449 364T395 420T322 440Q283 440 250 421T197 366T176 279Q176 229 196 192T250 134T322 114Q361 114 395 133Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    glyphName: "ccedilla",
    horizAdvX: 602,
    d: "M391 111T417 187H568Q547 106 491 55T349 -6V-45Q404 -45 441 -73T479 -154Q479 -208 441 -237T346 -266H204V-184H323Q347 -184 359 -177T372 -152Q372 -134 360 -128T323 -121H261V-6Q193 4 142 41T62 139T33 277Q33 363 68 427T165 527T307 563Q410 563 477 512T568 367H417Q405 403 377 423T306 444Q246 444 211 401T176 277Q176 198 211 155T306 111Q391 111 417 187Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    glyphName: "egrave",
    horizAdvX: 617,
    d: "M584 259T580 235H175Q180 175 217 141T308 107Q386 107 419 174H570Q546 94 478 43T311 -9Q231 -9 168 26T69 127T33 277Q33 363 68 428T166 528T311 563Q390 563 452 529T549 433T584 289Q584 259 580 235ZM439 329Q438 383 400 415T307 448Q255 448 220 417T176 329H439ZM418 695V595L188 700V814L418 695Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    glyphName: "eacute",
    horizAdvX: 617,
    d: "M584 259T580 235H175Q180 175 217 141T308 107Q386 107 419 174H570Q546 94 478 43T311 -9Q231 -9 168 26T69 127T33 277Q33 363 68 428T166 528T311 563Q390 563 452 529T549 433T584 289Q584 259 580 235ZM439 329Q438 383 400 415T307 448Q255 448 220 417T176 329H439ZM418 700L188 595V695L418 814V700Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    glyphName: "ecircumflex",
    horizAdvX: 617,
    d: "M584 259T580 235H175Q180 175 217 141T308 107Q386 107 419 174H570Q546 94 478 43T311 -9Q231 -9 168 26T69 127T33 277Q33 363 68 428T166 528T311 563Q390 563 452 529T549 433T584 289Q584 259 580 235ZM439 329Q438 383 400 415T307 448Q255 448 220 417T176 329H439ZM309 679L160 595V697L309 778L457 697V595L309 679Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    glyphName: "edieresis",
    horizAdvX: 617,
    d: "M584 259T580 235H175Q180 175 217 141T308 107Q386 107 419 174H570Q546 94 478 43T311 -9Q231 -9 168 26T69 127T33 277Q33 363 68 428T166 528T311 563Q390 563 452 529T549 433T584 289Q584 259 580 235ZM439 329Q438 383 400 415T307 448Q255 448 220 417T176 329H439ZM188 622T169 641T150 688Q150 716 169 735T216 755Q244 755 263 736T283 688Q283 660 264 641T216 622Q188 622 169 641ZM373 622T354 641T335 688Q335 716 354 735T401 755Q429 755 448 736T468 688Q468 660 449 641T401 622Q373 622 354 641Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    glyphName: "igrave",
    horizAdvX: 290,
    d: "M215 554V0H75V554H215ZM254 693V593L24 698V812L254 693Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    glyphName: "iacute",
    horizAdvX: 290,
    d: "M215 554V0H75V554H215ZM254 698L24 593V693L254 812V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    glyphName: "icircumflex",
    horizAdvX: 290,
    d: "M215 554V0H75V554H215ZM402 677L253 593V695L402 776L550 695V593L402 677Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    glyphName: "idieresis",
    horizAdvX: 290,
    d: "M215 554V0H75V554H215ZM280 620T261 639T242 686Q242 714 261 733T308 753Q336 753 355 734T375 686Q375 658 356 639T308 620Q280 620 261 639ZM465 620T446 639T427 686Q427 714 446 733T493 753Q521 753 540 734T560 686Q560 658 541 639T493 620Q465 620 446 639Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    glyphName: "eth",
    horizAdvX: 638,
    d: "M540 580T572 495T605 317Q605 213 568 140T465 29T317 -8Q237 -8 173 27T71 128T33 278Q33 363 69 427T168 527T306 562Q383 562 445 517Q421 572 380 624L264 588V652L335 675Q311 701 264 740H398Q411 729 434 706L546 741V677L479 656Q540 580 572 495ZM355 111T388 129T441 185T461 277Q461 331 441 368T388 424T318 443Q280 443 248 425T197 369T177 277Q177 197 217 154T317 111Q355 111 388 129Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    glyphName: "ntilde",
    horizAdvX: 661,
    d: "M475 562T536 500T597 325V0H457V306Q457 372 424 407T334 443Q276 443 243 408T209 306V0H69V554H209V485Q237 521 280 541T376 562Q475 562 536 500ZM176 673T208 705T291 738Q312 738 328 732T364 713Q394 694 414 694Q451 694 457 737H532Q523 671 491 639T408 606Q387 606 371 612T335 631Q306 651 285 651Q248 651 241 607H167Q176 673 208 705Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    glyphName: "ograve",
    horizAdvX: 638,
    d: "M235 -9T171 26T71 127T34 277Q34 362 71 427T174 527T319 563Q399 563 464 528T566 427T604 277Q604 192 566 127T462 27T315 -9Q235 -9 171 26ZM353 113T386 131T440 187T460 277Q460 356 419 398T317 441Q257 441 217 399T176 277Q176 198 215 156T315 113Q353 113 386 131ZM434 700V600L204 705V819L434 700Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    glyphName: "oacute",
    horizAdvX: 638,
    d: "M235 -9T171 26T71 127T34 277Q34 362 71 427T174 527T319 563Q399 563 464 528T566 427T604 277Q604 192 566 127T462 27T315 -9Q235 -9 171 26ZM353 113T386 131T440 187T460 277Q460 356 419 398T317 441Q257 441 217 399T176 277Q176 198 215 156T315 113Q353 113 386 131ZM434 705L204 600V700L434 819V705Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    glyphName: "ocircumflex",
    horizAdvX: 638,
    d: "M235 -9T171 26T71 127T34 277Q34 362 71 427T174 527T319 563Q399 563 464 528T566 427T604 277Q604 192 566 127T462 27T315 -9Q235 -9 171 26ZM353 113T386 131T440 187T460 277Q460 356 419 398T317 441Q257 441 217 399T176 277Q176 198 215 156T315 113Q353 113 386 131ZM325 684L176 600V702L325 783L473 702V600L325 684Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    glyphName: "otilde",
    horizAdvX: 638,
    d: "M235 -9T171 26T71 127T34 277Q34 362 71 427T174 527T319 563Q399 563 464 528T566 427T604 277Q604 192 566 127T462 27T315 -9Q235 -9 171 26ZM353 113T386 131T440 187T460 277Q460 356 419 398T317 441Q257 441 217 399T176 277Q176 198 215 156T315 113Q353 113 386 131ZM154 680T186 712T269 745Q290 745 306 739T342 720Q372 701 392 701Q429 701 435 744H510Q501 678 469 646T386 613Q365 613 349 619T313 638Q284 658 263 658Q226 658 219 614H145Q154 680 186 712Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    glyphName: "odieresis",
    horizAdvX: 638,
    d: "M235 -9T171 26T71 127T34 277Q34 362 71 427T174 527T319 563Q399 563 464 528T566 427T604 277Q604 192 566 127T462 27T315 -9Q235 -9 171 26ZM353 113T386 131T440 187T460 277Q460 356 419 398T317 441Q257 441 217 399T176 277Q176 198 215 156T315 113Q353 113 386 131ZM204 627T185 646T166 693Q166 721 185 740T232 760Q260 760 279 741T299 693Q299 665 280 646T232 627Q204 627 185 646ZM389 627T370 646T351 693Q351 721 370 740T417 760Q445 760 464 741T484 693Q484 665 465 646T417 627Q389 627 370 646Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    glyphName: "divide",
    horizAdvX: 648,
    d: "M293 496T269 519T244 578Q244 613 268 636T331 660Q368 660 392 637T416 578Q416 543 392 520T331 496Q293 496 269 519ZM583 418V296H73V418H583ZM293 55T269 78T244 137Q244 172 268 195T331 219Q368 219 392 196T416 137Q416 102 392 79T331 55Q293 55 269 78Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    glyphName: "oslash",
    horizAdvX: 634,
    d: "M535 469Q567 432 584 383T602 277Q602 192 564 127T460 27T313 -9Q217 -9 144 42L106 0H21L98 84Q66 122 49 171T32 277Q32 362 69 427T172 527T317 563Q416 563 489 511L528 554H613L535 469ZM174 226T192 187L400 414Q363 441 315 441Q255 441 215 399T174 277Q174 226 192 187ZM458 326T440 365L233 138Q267 113 313 113Q351 113 384 131T438 187T458 277Q458 326 440 365Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    glyphName: "ugrave",
    horizAdvX: 661,
    d: "M592 554V0H451V70Q424 34 381 14T286 -7Q221 -7 171 20T93 101T64 229V554H204V249Q204 183 237 148T327 112Q385 112 418 147T451 249V554H592ZM440 693V593L210 698V812L440 693Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    glyphName: "uacute",
    horizAdvX: 661,
    d: "M592 554V0H451V70Q424 34 381 14T286 -7Q221 -7 171 20T93 101T64 229V554H204V249Q204 183 237 148T327 112Q385 112 418 147T451 249V554H592ZM440 698L210 593V693L440 812V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    glyphName: "ucircumflex",
    horizAdvX: 661,
    d: "M592 554V0H451V70Q424 34 381 14T286 -7Q221 -7 171 20T93 101T64 229V554H204V249Q204 183 237 148T327 112Q385 112 418 147T451 249V554H592ZM331 677L182 593V695L331 776L479 695V593L331 677Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    glyphName: "udieresis",
    horizAdvX: 661,
    d: "M592 554V0H451V70Q424 34 381 14T286 -7Q221 -7 171 20T93 101T64 229V554H204V249Q204 183 237 148T327 112Q385 112 418 147T451 249V554H592ZM210 620T191 639T172 686Q172 714 191 733T238 753Q266 753 285 734T305 686Q305 658 286 639T238 620Q210 620 191 639ZM395 620T376 639T357 686Q357 714 376 733T423 753Q451 753 470 734T490 686Q490 658 471 639T423 620Q395 620 376 639Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    glyphName: "yacute",
    horizAdvX: 605,
    d: "M599 554L256 -262H107L227 14L5 554H162L305 167L450 554H599ZM412 698L182 593V693L412 812V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    glyphName: "thorn",
    horizAdvX: 678,
    d: "M237 512T282 537T388 562Q459 562 518 526T611 426T645 278Q645 195 611 130T518 28T388 -8Q328 -8 283 19T209 93V-264H69V740H209V468Q237 512 282 537ZM502 329T482 366T428 421T356 440Q318 440 285 421T230 365T209 277Q209 226 230 189T284 133T356 114Q394 114 427 133T481 189T502 278Q502 329 482 366Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    glyphName: "ydieresis",
    horizAdvX: 605,
    d: "M599 554L256 -262H107L227 14L5 554H162L305 167L450 554H599ZM182 620T163 639T144 686Q144 714 163 733T210 753Q238 753 257 734T277 686Q277 658 258 639T210 620Q182 620 163 639ZM367 620T348 639T329 686Q329 714 348 733T395 753Q423 753 442 734T462 686Q462 658 443 639T395 620Q367 620 348 639Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    glyphName: "endash",
    horizAdvX: 702,
    d: "M623 416V298H79V416H623Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    glyphName: "emdash",
    horizAdvX: 927,
    d: "M848 416V298H79V416H848Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    glyphName: "quoteleft",
    horizAdvX: 275,
    d: "M179 446H31L139 698H236L179 446Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    glyphName: "quoteright",
    horizAdvX: 275,
    d: "M97 698H244L136 446H40L97 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    glyphName: "quotesinglbase",
    horizAdvX: 251,
    d: "M71 148H219L111 -104H14L71 148Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    glyphName: "quotedblleft",
    horizAdvX: 477,
    d: "M179 446H31L139 698H236L179 446ZM381 446H233L341 698H438L381 446Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    glyphName: "quotedblright",
    horizAdvX: 477,
    d: "M97 698H244L136 446H40L97 698ZM299 698H446L338 446H242L299 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    glyphName: "quotedblbase",
    horizAdvX: 454,
    d: "M72 148H219L111 -104H15L72 148ZM274 148H422L314 -104H217L274 148Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    glyphName: "bullet",
    horizAdvX: 480,
    d: "M201 194T169 212T119 263T100 333Q100 372 118 404T169 454T239 473Q278 473 310 455T361 404T380 333Q380 295 362 263T311 213T239 194Q201 194 169 212Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    glyphName: "guilsinglleft",
    horizAdvX: 316,
    d: "M133 120L45 295L133 470H266L174 295L266 120H133Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    glyphName: "guilsinglright",
    horizAdvX: 316,
    d: "M141 295L50 470H182L271 295L182 120H50L141 295Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoppinsV19Latin600);
export default __webpack_public_path__ + "static/media/poppins-v19-latin-600.604adf2932b4c681a98853d5f968eef4.svg";
export { ForwardRef as ReactComponent };